<template>
    <ExtendedLayout
        :project="project"
        currentTab="properties"
    >

        <Panel>

            <Heading type="h2" class="flex items-center gap-2">
                <InertiaLink :href="$route('admin::projects.properties.index', { project: project.id })">
                    {{ __('admin::properties.properties') }}
                </InertiaLink>
                <ChevronRightIcon class="h-4 w-4 text-gray-600" />
                <span>#{{ property.id }}</span>
            </Heading>

            <div class="bg-blue-100 border border-blue-300 text-blue-700 px-4 py-3 text-sm font-medium mb-3" v-if="readOnly">
                {{ __('admin::properties.synced_with_feed_so_read_only') }}
            </div>

            <form @submit.prevent="submit">

                <FormGroup :label="__('admin::labels.feed')" :error="errors.project_feed_id">
                    <Input :modelValue="property.project_feed.name" disabled v-if="readOnly" />
                    <Select name="project_feed_id" :options="feedOptions" :has-error="exists(errors.project_feed_id)" v-model="form.project_feed_id" :required="true" v-else />
                </FormGroup>

                <FormGroup :label="__('admin::labels.external_id')" :error="errors.external_id">
                    <Input type="text" name="external_id" :has-error="exists(errors.external_id)" v-model="form.external_id" :required="true" :disabled="readOnly" />
                </FormGroup>

                <PropertyDataFields
                    :columns="columns"
                    v-model="form.property_data"
                    :readOnly="readOnly"
                />

                <Button :loading="form.processing" v-if="! readOnly">
                    {{ __('admin::general.update_model', {'model': __('admin::properties.property').toLowerCase() }) }}
                </Button>

            </form>

        </Panel>

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@/Pages/Projects/Edit';
import Panel from "@/Components/Panel";
import Button from "@/Components/Button";
import FormGroup from "@/Components/FormGroup";
import Input from "@/Components/Input";
import Heading from "@/Components/Heading";
import {ChevronRightIcon} from "@heroicons/vue/outline";
import Select from "@/Components/Select";
import PropertyDataFields from "@/Components/PropertyDataFields.vue";

export default {
    components: {
        PropertyDataFields,
        Select,
        ChevronRightIcon,
        Heading,
        Input,
        FormGroup,
        Button,
        Panel,
        ExtendedLayout,
    },
    props: {
        errors: Object,
        project: Object,
        property: Object,
        feedOptions: Object,
        columns: Object,
    },
    data() {
        return {
            readOnly: this.property.project_feed.type !== 'manual',
            form: this.$inertia.form({
                project_feed_id: this.property.project_feed_id,
                external_id: this.property.external_id,
                property_data: (typeof this.property.data === 'object' && ! Array.isArray(this.property.data)) ? this.property.data : {},
            })
        }
    },
    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.$route('admin::projects.properties.update', { project: this.project.id, property: this.property.id }));
        }
    },
}
</script>
